"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardMessageFormatOption')(function discardMessageFormatOption(state) {
    var optionState = state.optionState;
    optionState.showBcc = null;
    optionState.showFrom = null;
    optionState.composeFormat = null;
    optionState.fontFamily = null;
    optionState.fontSize = null;
    optionState.isFontBold = null;
    optionState.isFontItalic = null;
    optionState.isFontUnderline = null;
    optionState.fontColor = null;
    optionState.isColorMenuShown = false;
}));
//# sourceMappingURL=discardMessageFormatOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/actions/discardMessageFormatOption.js
// module id = 5159
// module chunks = 2